import { useContentfulConfigs } from '@vfmfe/foundations';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from '../modules/store';
import { getHeader } from '../queries';
import { THeader } from '../types/header';

export function useHeader({ name }: { name: string }) {
    const [headerData, setHeaderData] = useState<THeader | null>(null);
    const [loading, setLoading] = useState(true);

    const contentfulConfigs = useContentfulConfigs({
        journey: 'digital-journey',
        contentfulConfiguration: { applicationId: 'Digital' }
    });
    const currentLanguage = useSelector((state) => state.shell.currentLanguage);

    const configRef = useRef(contentfulConfigs);

    useEffect(() => {
        configRef.current = contentfulConfigs;
    }, [contentfulConfigs]);

    useEffect(() => {
        const fetchHeaderData = async () => {
            try {
                setLoading(true);
                const data = await getHeader({ locale: currentLanguage, config: configRef.current, name });
                setHeaderData(data);
            } catch (error) {
                console.error('Failed to fetch header:', error);
                setHeaderData(null);
            } finally {
                setLoading(false);
            }
        };

        if (configRef.current) {
            fetchHeaderData();
        }
    }, [currentLanguage]);

    return { headerData, loading };
}
